import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [``],
})
export class PageMainComponent implements OnInit, DoCheck {
    public mode = '';
    public step = 1;

    constructor(@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.service.render();
    }

    public async ngDoCheck() {
        if (this.mode == WizRoute.segment.mode) return;
        this.mode = WizRoute.segment.mode;
        await this.service.render();
    }

}

export default PageMainComponent;